import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class VatStatementMappingItem  {
    _originalTypeClassName = "zERP.BO.VatStatementMappingItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
VatStatementMappingItem.translate = translateService;
}
this.InvoiceTypes = [];
this.VatTypes = [];
this.Id = null;
this.FieldName = null;
this.HasSpecificTransactionItemType = false;
this.IsAsset = false;
this.IsGood = false;
this.IsService = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FieldName:any;
HasSpecificTransactionItemType:any;
IsAsset:any;
IsGood:any;
IsService:any;
InvoiceTypes:any;
VatTypes:any;
static setInvoiceTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.InvoiceTypes == null) $this.InvoiceTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InvoiceTypes.length > 0) {
                    Domain.VatStatementMappingItem.removeInvoiceTypes($this, $this.InvoiceTypes[0]);
                }

                Domain.VatStatementMappingItem.addManyInvoiceTypes($this, copyItems);
            }
static addManyInvoiceTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.VatStatementMappingItem.addInvoiceTypes($this, items[i]);
                }
            }
static addInvoiceTypes = ($this, item) => {
                if ($this.InvoiceTypes == null) $this.InvoiceTypes = [];
                if (item == null || $this.InvoiceTypes.indexOf(item) > -1) return;
                $this.InvoiceTypes.push(item);
}
static addRangeInvoiceTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.VatStatementMappingItem.addInvoiceTypes($this, item));
            }
static removeInvoiceTypes = ($this, item) => {
                if ($this == null || $this.InvoiceTypes == null || $this.InvoiceTypes.indexOf(item) === -1) return;
                var _index = $this.InvoiceTypes.indexOf(item);
                $this.InvoiceTypes.splice(_index, 1);
}
static clearInvoiceTypes = ($this) => { $this.InvoiceTypes = null; }
static setVatTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.VatTypes == null) $this.VatTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.VatTypes.length > 0) {
                    Domain.VatStatementMappingItem.removeVatTypes($this, $this.VatTypes[0]);
                }

                Domain.VatStatementMappingItem.addManyVatTypes($this, copyItems);
            }
static addManyVatTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.VatStatementMappingItem.addVatTypes($this, items[i]);
                }
            }
static addVatTypes = ($this, item) => {
                if ($this.VatTypes == null) $this.VatTypes = [];
                if (item == null || $this.VatTypes.indexOf(item) > -1) return;
                $this.VatTypes.push(item);
}
static addRangeVatTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.VatStatementMappingItem.addVatTypes($this, item));
            }
static removeVatTypes = ($this, item) => {
                if ($this == null || $this.VatTypes == null || $this.VatTypes.indexOf(item) === -1) return;
                var _index = $this.VatTypes.indexOf(item);
                $this.VatTypes.splice(_index, 1);
}
static clearVatTypes = ($this) => { $this.VatTypes = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}